export default {"src":"/_next/static/media/comment.4d2a580e.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};